import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createBookingBookmark } from '@/features/auth'

export const useBookingBookmarkCreate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createBookingBookmark,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['getBookingBookmarks'],
      })
    },
  })
}
